import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { isAuth } from "../../actions/auth";

const CompanyAuth = (props) => {
    const { history, children } = props;

    useEffect(() => {
        if (!isAuth()) {
            history.replace("/company/signin");
        } else {
            const role = isAuth().role;
            // If role is not 0 (Company), redirect to their appropriate dashboard
            if (role !== 0) {
                // Staff/Admin or others
                history.push("/admin");
            }
        }
    }, [history]);

    return <React.Fragment>{children}</React.Fragment>;
};

export default withRouter(CompanyAuth);
